import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { Device, DeviceCart, DeviceFeature, FeatureImage, Role } from '@kion/data-models';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {BehaviorSubject} from 'rxjs';
enum DeviceStates {
  'INCOMPATIBLE' = 'incompatible',
  'INSTALLED' = 'installed',
  'ACTIVATED' = 'activated',
  'ORDERED' = 'ordered',
  'SUPPORT_NEEDED' = 'support_needed',
  'ADDED_TO_BASKET' = 'added_to_basket'
}

@Component({
  selector: 'kion-feature-list-item',
  templateUrl: './feature-list-item.component.html',
  styleUrls: ['./feature-list-item.component.scss']
})
export class FeatureListItemComponent implements OnChanges, AfterViewInit {

  @Input() feature: DeviceFeature;
  @Input() device: Device;
  @Input() cart: DeviceCart;
  @Input() roles: Role[];

  @ViewChild('detailModal') detailModal;

  // tslint:disable-next-line:no-output-rename
  @Output('addToCart') addToCartClickedEmitter: EventEmitter<{ean: string, salesRule: string}> = new EventEmitter<{ean: string, salesRule: string}>();

  images$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  isAddingToBasket: boolean;

  constructor(private modalService: NgbModal) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.feature) {
      this.feature = changes.feature.currentValue;
    }
    if (changes.cart) {
      this.cart = changes.cart.currentValue;
    }
    if (this.feature && this.cart) {
      this.cart.entries.forEach(
        entry => {
          if (entry.product.code === this.feature.id) {
            this.feature  = {
              ...this.feature,
              status: 'ADDED_TO_BASKET'
            }
          }
        }
      )
    }
  }

  ngAfterViewInit(): void {
    this.featureImages();
  }

  get featureDetail(): DeviceFeature {
    return this.device.products.find(feature => feature.code === this.feature.id)
  }

  get featureStatus(): string {
    if (!this.feature) {
      return 'support_needed';
    }
    const status = DeviceStates[this.feature.status];
    if (status) {
      return status;
    }
    return 'support_needed';
  }

  get hidePrice(): boolean {
    if (!this.feature) {
      return true;
    }
    return (['added_to_basket', 'ordered', 'installed', 'incompatible', 'support_needed','activated'].includes(DeviceStates[this.feature.status]));
  }

  get hideStatus(): boolean {
    if (!this.feature) {
      return true;
    }
    return !(['added_to_basket', 'ordered', 'installed', 'incompatible', 'support_needed','activated'].includes(DeviceStates[this.feature.status]));
  }

  get status(): 'success' | 'error' {
    if (!this.feature) {
      return 'error';
    }
    return this.feature.status === 'INCOMPATIBLE' || this.feature.status === 'SUPPORT_NEEDED'  ? 'error' : 'success'
  }

  get isInstalled(): boolean {
    return (['installed','activated'].includes(DeviceStates[this.feature.status]));
  }

  get hideAddToBasket(): boolean {
    if (DeviceStates[this.feature.status] === 'added_to_basket') {
      this.isAddingToBasket = false;
    }
    return ['added_to_basket', 'ordered', 'installed','activated'].includes(DeviceStates[this.feature.status])
  }

  get canSeeAddToBasket(): boolean {
    if (this.roles) {
      if (this.roles.map(role => role.role.uid).includes('fsNwpBuyer')) {
        return true
      }
      return this.roles.map(role => role.role.uid).includes('fsNwpApprover');
    }
  }

  get isTruckHealthManagement(): boolean {
    return !!this.feature.truckHealthManagement;
  }

  featureImages(): void {
    const device = this.device.products.find(feature => feature.code === this.feature.id);
    if (device) {
      const images =  device?.images?.map(
        (image: FeatureImage, index: number) => {
          return {
            type: "image",
            id: index,
            url: {
              lazyLoad: image.url + '?width=310&height=310&padColor=fff',
              default: image.url + '?width=50&height=50&padColor=fff',
              error: './assets/ui/shared/error/not_found_error_image.png'
            },
            altText: image.altText,
            titleText: image.titleText
          }
        }
      );
      if (this.images$.value !== images) {
        this.images$.next(images);
      }
    }
  }

  featureClicked(event: MouseEvent): void {
    this.openDetailsModal()
  }

  private openDetailsModal(): void {
    this.modalService.open(this.detailModal);
  }

  detailsButtonClicked(event: MouseEvent): void {
    event.stopPropagation();
    this.openDetailsModal()
  }

  addToCartClicked(event: MouseEvent) {
    event.stopPropagation();
    this.isAddingToBasket = true;
    setTimeout(() => {
      this.isAddingToBasket = false;
    }, 7000);
    this.addToCartClickedEmitter.emit(
      {
        ean: this.feature.ean,
        salesRule: this.feature?.salesRule?.code
      }
    )
  }
}
